import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="foot">
      <div className="container foot__inner">
        <div className="foot__brand">
          <Link to="/" className="foot__logo" aria-label="AinaSuite home">
            <img
              src="/ainasuite_dark_top.png"
              alt="AinaSuite"
              className="foot__brandImg"
            />
          </Link>
          <p className="foot__tag">
            The omnichannel AI chat platform built for modern customer teams.
          </p>
          <div className="foot__social">
            <a href="#twitter" aria-label="twitter"><Twitter size={16} /></a>
            <a href="#linkedin" aria-label="linkedin"><Linkedin size={16} /></a>
          </div>
        </div>

        <div className="foot__cols">
          <div className="foot__col">
            <div className="foot__head">Product</div>
            <Link to="/#features">Features</Link>
            <Link to="/#channels">Channels</Link>
            <Link to="/#pricing">Pricing</Link>
            <Link to="/#how">How it works</Link>
          </div>
          <div className="foot__col">
            <div className="foot__head">Solutions</div>
            <a href="#sales">Sales</a>
            <a href="#support">Customer support</a>
            <a href="#booking">Appointment booking</a>
            <a href="#realestate">Real estate</a>
          </div>
          <div className="foot__col">
            <div className="foot__head">Legal</div>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/cookies">Cookie Policy</Link>
            <Link to="/refund">Refund Policy</Link>
          </div>
        </div>
      </div>
      <div className="foot__bottom">
        <div className="container foot__bottomInner">
          <span>© {new Date().getFullYear()} AinaSuite . All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
